import { Context } from '../..';
import { DigitalSignatureType } from '../../../enums/digital-signature-type';
import * as base from '../base';

export async function saveDigitalSignature(context: Context, digitalSignatureType: DigitalSignatureType): Promise<void> {
  const request: base.IRequest = { url: base.apiURL(`digitalsignature`, `save-digital-signature`, digitalSignatureType.toString(), `true`), authenticated: true, method: 'POST' };
  await base.request(request);
}
